import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Flame, Share2 } from "lucide-react";

const TIERS = [
  { days: 3, label: "3-DAY" },
  { days: 7, label: "7-DAY" },
  { days: 30, label: "30-DAY" },
];

/** Creator share streak — one share a day keeps the flame alive. */
export default function StreakBadge() {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/me/streak").then((r) => setS(r.data)).catch(() => {});
  }, []);

  if (!s) return null;

  return (
    <div className="border border-[#3a3a3a] bg-[#121212] p-5 mt-6" data-testid="streak-card">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-4">
          <div className={`w-12 h-12 flex items-center justify-center border ${
            s.current_streak > 0 ? "border-[#ff6b35] bg-[#ff6b35]/10" : "border-[#3a3a3a]"
          }`}>
            <Flame size={22} className={s.current_streak > 0 ? "text-[#ff6b35]" : "text-[#b8b8b8]"} />
          </div>
          <div>
            <div className="font-display font-black text-2xl leading-none" data-testid="streak-count">
              {s.current_streak} day{s.current_streak === 1 ? "" : "s"}
            </div>
            <div className="font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0] mt-1">
              Share streak · best {s.best_streak}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {TIERS.map((t) => (
            <span
              key={t.days}
              data-testid={`streak-tier-${t.days}`}
              className={`font-mono text-[10px] uppercase tracking-widest border px-2 py-1 ${
                s.best_streak >= t.days
                  ? "border-[#ff6b35] text-[#ff6b35]"
                  : "border-[#3a3a3a] text-[#b8b8b8]"
              }`}
            >
              <Flame size={8} className="inline -mt-0.5 mr-1" />{t.label}
            </span>
          ))}
        </div>
      </div>
      <p className="font-mono text-[11px] text-[#d0d0d0] mt-3 flex items-center gap-1.5" data-testid="streak-hint">
        <Share2 size={10} />
        {s.shared_today
          ? "Today counted — come back tomorrow to keep the flame."
          : "Share any of your coins today (X, Telegram, or copy link) to grow the streak."}
      </p>
    </div>
  );
}
